import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-git-branch-02',
  standalone: true,
  templateUrl: './rt-icon-git-branch-02.component.html',
  styleUrls: ['./rt-icon-git-branch-02.component.scss']
})
export class RtIconGitBranch02Component {
  @Input() width: number | string = 12;
  @Input() height: number | string = 12;
}
